import { FormEvent, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DefaultModal } from "../../common/modals/default-modal/default-modal";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import defaultStyles from "../../common/modals/default-modal/default-modal.less";
import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { useDispatch } from "react-redux";
import { FormattedVerificationServiceConfiguration } from "@idw-types/data/verification-service-configuration";
import { removeVerificationServiceConfiguration } from "@redux/actions/verification-services-actions";
import { ModalSizeTypes } from "@enums/modal-size-types";
import { deleteVerificationServiceRequest } from "@requests/service-configuration";

type DeleteVerificationServiceModalProps = {
    onModalClose: () => void;
    verificationServiceConfiguration: FormattedVerificationServiceConfiguration;
};

export const DeleteVerificationServiceModal = (props: DeleteVerificationServiceModalProps) => {
    const dispatch = useDispatch();
    const { onModalClose, verificationServiceConfiguration } = props;

    const [requestInProgress, setRequestInProgress] = useState(false);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        setRequestInProgress(true);
        const { data, error } = await deleteVerificationServiceRequest(verificationServiceConfiguration.id);
        if (data) {
            displaySuccessModal(
                dispatch,
                resources.requests.deleteVerificationService.success.title,
                resources.requests.deleteVerificationService.success.message
            );

            dispatch(removeVerificationServiceConfiguration(verificationServiceConfiguration));
            onModalClose();
        } else {
            if (error) {
                logAndDisplayErrorModal(
                    dispatch,
                    error,
                    resources.requests.deleteVerificationService.error.title,
                    resources.requests.deleteVerificationService.error.message,
                    error
                );
            }
            setRequestInProgress(false);
        }
    };

    return (
        <DefaultModal
            automationId="delete-verification-service-modal"
            ariaLabelledBy="delete-verification-service-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
            size={ModalSizeTypes.MEDIUM}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={"delete-verification-service-title"} closeButton>
                    <Modal.Title>{resources.modals.deleteVerificationService.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className={defaultStyles.description}>
                        {resources.modals.deleteVerificationService.description}
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="delete-verification-service-cancel" variant="secondary" onClick={onModalClose}>{resources.common.buttons.cancel.label}</Button>
                    <ButtonWithSpinner
                        id="delete-verification-service-submit"
                        disabled={requestInProgress}
                        hideSpinner={false}
                        variant="primary"
                        type={ButtonTypes.SUBMIT}
                        label={resources.modals.deleteVerificationService.buttons.deleteService.label}
                    />
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};